import axios from 'axios';

export const searchSubFunction = (subfunction, geneID, vue) => {
    // console.log("------123123")
        // console.log(vue);
        // console.log(subfunction)
        // console.log(geneID)
        // this.show_tandem = 0;
        // let that = this;
        let _this = vue;
        if (subfunction == 'JBrowse') {
            // console.log('OKOKOOK')
            axios({
                url: 'http://39.100.233.196:8001/api/search-JBrowse-gene/',
                type: 'json',
                params: {
                    geneID
                },
                method: 'get',
            }).then((res)=>{
                // console.log(res.data[0])
                var species = res.data[0].species
                var chromosome = res.data[0].chromosome
                var startPos = (res.data[0].startPos - 300).toString()
                var endPos = (res.data[0].endPos + 300).toString()
                // console.log(endPos)
                // this.$router.push({path: "../SearchJBrowse/", query:{Genome: species, Chromosome:chromosome, StartPos:startPos, EndPos: endPos}});
                // console.log(vue);
                let routeUrl = _this.$router.resolve({
                    path: "../SearchJBrowse/",
                    query:{Genome: species,
                        Chromosome:chromosome,
                        StartPos:startPos,
                        EndPos: endPos}
                });
                // console.log(routeUrl.href)
                window.open(routeUrl.href, '_blank');
            })
        }
        else if (subfunction == 'Gene sequence') {
            let routeUrl = _this.$router.resolve({
                path: "../GeneSequence/",
                query: {Gene: geneID}
            });
            window.open(routeUrl.href, '_blank');
        }
        else if (subfunction == 'Syntenic gene') {
            let routeUrl = _this.$router.resolve({
                path: "../syntenic-gene/",
                query: {Gene: geneID}
            });
            window.open(routeUrl.href, '_blank');
        }
        else if (subfunction == 'Flanking region') {
            let routeUrl = _this.$router.resolve({
                path: "../FlankingRegion/",
                query: {Gene: geneID}
            });
            window.open(routeUrl.href, '_blank');
        }
        else if (subfunction == 'Annotations') {
            let routeUrl = _this.$router.resolve({
                path: "../Annotations/",
                query: {Gene: geneID}
            });
            window.open(routeUrl.href, '_blank');
        }
        else if (subfunction == 'Nonsyntenic orth') {
            let routeUrl = _this.$router.resolve({
                path: "../NonSyntenicOrthologs/",
                query: {Gene: geneID}
            });
            window.open(routeUrl.href, '_blank')
        }
        else if (subfunction == 'Flanking Primer') {
            let routeUrl = _this.$router.resolve({
                path: "../PrimerDesign/",
                query: {Gene: geneID}
            });
            window.open(routeUrl.href, '_blank')
        }
        else if (subfunction == 'Polymorph') {
            let routeUrl = _this.$router.resolve({
                path: "../Polymorph/",
                query: {Gene: geneID}
            });
            window.open(routeUrl.href, '_blank')
        }
        else if (subfunction == 'BrapaLeafeFP') {
            let routeUrl = _this.$router.resolve({
                path: "../BrapaLeafeFP/",
                query: {Gene: geneID}
            });
            window.open(routeUrl.href, '_blank')
        }
        else if (subfunction == 'BrapaLeafCelleFP') {
            let routeUrl = _this.$router.resolve({
                path: "../BrapaLeafCelleFP/",
                query: {Gene: geneID}
            });
            window.open(routeUrl.href, '_blank')
        }
        else if (subfunction == 'AthBestHit') {
            let routeUrl = _this.$router.resolve({
                path: "../AthBestHit/",
                query: {Gene: geneID}
            });
            window.open(routeUrl.href, '_blank')
        }
        // else if (subfunction == 'ProteinStructure') {
        //     let routeUrl = _this.$router.resolve({
        //         path: "../ProteinStructure/",
        //         query: {Gene: geneID}
        //     });
        //     window.open(routeUrl.href, '_blank')
        // }
        else if (subfunction == 'Coge') {
            window.open('https://genomevolution.org/CoGe/FeatView.pl?accn=' + geneID, '_blank');
        }
        else if (subfunction == 'TAIR') {
            window.open('https://www.arabidopsis.org/servlets/TairObject?name=' + geneID + '&type=locus');
        }
        else if (subfunction == 'Expression in At eFP') {
            window.open('http://bar.utoronto.ca/efp/cgi-bin/efpWeb.cgi?primaryGene=' + geneID)
        }
        else if (subfunction == 'AlphaFold') {
            window.open('https://alphafold.ebi.ac.uk/search/text/' + geneID)
        }
        else if (subfunction == 'MicroSynteny') {
            this.show_subgenome = 1;
            this.boxtarget = 0;
            this.Ath10_boxtarget = 0;
            this.Bra_boxtarget = 0;
        }
        else if (subfunction == 'Transcriptome') {
            let routeUrl = _this.$router.resolve({
                path: "../Transcriptome/",
                query: {Gene: geneID}
            });
            window.open(routeUrl.href, '_blank')
        }
    }


    export default {
        searchSubFunction:searchSubFunction
    }